module.exports = "/assets/data/f63308c0385d139db12dc95c38c8e1a4-DN5.data.json";